const assoSwitchesDefaultRc = {
  legal_protection: true,
  civil_responsibility_asso: true,
  local_insurance: false,
  social_mandate_responsibility: false,
  extended_legal_protection: false,
  classic_accident_insurance: false,
  reinforced_accident_insurance: false
};

const assoSwitchesDefaultLocal = {
  local_insurance: true,
  exploitation_loss: false,
  legal_protection: true,
  social_mandate_responsibility: false,
  extended_legal_protection: false,
  light_inflatable_structure: false,
  classic_accident_insurance: false,
  reinforced_accident_insurance: false
};

export { assoSwitchesDefaultRc, assoSwitchesDefaultLocal };
